module.exports = __webpack_public_path__ + "static/media/61e6249b-b816-47bc-9ddf-b67e026bf1e5.f6b849c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/61e6249b-b816-47bc-9ddf-b67e026bf1e5.jpg
// module id = 823
// module chunks = 0